import './block.png';
import './block_mobile.png';
import './index.scss';
import 'components/user/avatar';
import AbuseReportModal from 'components/modals/abuse_report_modal';
import CommentReplies from '../comment_replies';
import QuestionLikes from '../question_likes';
import QuestionRepliesEditor from '../comment_replies/comment_replies_editor';
import { EventManager } from 'utils/event_manager';
import { errorInterpreter } from 'utils/error_interpreter';

export default class QuestionComment {
  constructor(context) {
    this.$context = $(context);
    this.isBlurred = this.$context.data().isBlurred;
    this.questionId = this.$context.data().questionId;
    this.commentId = this.$context.data().commentId;
    this.$reportButton = $('.js-report-abuse-btn', this.$context);
    this.$replyButton = $('.js-reply-comment-btn', this.$context);
    this.$deleteButton = $('.js-delete-comment-btn', this.$context);
    this.$editButton = $('.js-edit-comment-btn', this.$context);
    this.$changeCommentTypeButton = $(
      '.js-change-comment-type-to-teacher',
      this.$context
    );

    new CommentReplies(this.$context);

    if (!this.isBlurred) {
      new QuestionLikes(this.$context);
    }

    this.bindAll();
  }

  bindAll() {
    this._bindReply();
    this._bindReportAbuse();
    this._bindDeleteComment();
    this._bindEditComment();
    this._bindCollapseIcon();
    this._bindChangeCommentType();
  }

  _bindReportAbuse() {
    if (this.isBlurred) {
      return;
    }

    this.$reportButton
      .off('click.question_comment_report_abuse')
      .on('click.question_comment_report_abuse', () => this.reportAbuse());
  }

  _bindChangeCommentType() {
    if (this.isBlurred) {
      return;
    }

    this.$changeCommentTypeButton
      .off('click.question_comment_recommendation')
      .on('click.question_comment_recommendation', e =>
        this.changeCommentType(e)
      );
  }

  _bindDeleteComment() {
    this.$deleteButton
      .off('click.question_comment_delete')
      .on('click.question_comment_delete', () => {
        EventManager.publish(`questionComment.${this.questionId}.delete`, {
          commentId: this.commentId
        });
      });
  }

  _bindEditComment() {
    this.$editButton
      .off('click.question_comment_edit')
      .on('click.question_comment_edit', () => {
        const commentHTML = $(
          '.js-question-comment-text',
          this.$context
        ).html();
        const eventName = `questionComment.${this.questionId}.populateEditor`;

        EventManager.publish(eventName, {
          commentHTML,
          commentId: this.commentId
        });
      });
  }

  _bindReply() {
    if (this.isBlurred) {
      return;
    }

    this.$replyButton.on('click', e => {
      e.preventDefault();
      const $reply = $('.js-question-reply', this.$context);
      $reply.toggleClass('hidden');
      new QuestionRepliesEditor(this.$context);
    });
  }

  _bindCollapseIcon() {
    const $button = $('.js-collapsible', this.$context);

    $button.on('click', e => {
      const $current = $(e.currentTarget).find('.q-icon-angle-down');
      $current.toggleClass('q-icon-angle-up');
    });
  }

  static createAndRender(questionId, segmentId, commentHTML) {
    return new Promise((resolve, reject) => {
      Thor.Commentary.create_and_render(
        {
          question_id: questionId
        },
        {
          data: {
            text: commentHTML,
            resource_id: questionId,
            segment_id: segmentId,
            source_project: 1,
            component_name: 'questions/question_comment'
          }
        }
      )
        .then(html => resolve(html))
        .catch(({ response }) => {
          errorInterpreter({
            message:
              'Ops! Não foi possível criar seu comentário nesse momento!',
            response
          });
          reject(response);
        });
    });
  }

  static updateAndRender(questionId, commentId, commentHTML) {
    return new Promise((resolve, reject) => {
      Thor.Commentary.update_and_render(
        {
          question_id: questionId,
          id: commentId
        },
        {
          data: {
            text: commentHTML,
            component_name: 'questions/question_comment'
          }
        }
      )
        .then(html => resolve(html))
        .catch(({ response }) => {
          errorInterpreter({
            message:
              'Ops! Não foi possível atualizar seu comentário nesse momento!',
            response
          });
          reject(response);
        });
    });
  }

  static delete(questionId, commentId) {
    return new Promise((resolve, reject) => {
      Thor.Commentary.delete(
        {
          question_id: questionId,
          id: commentId
        },
        {}
      )
        .then(html => resolve(html))
        .catch(({ response }) => {
          errorInterpreter({
            message:
              'Ops! Não foi possivel excluir o seu comentário nesse momento!',
            response
          });
          reject(response);
        });
    });
  }

  reportAbuse() {
    AbuseReportModal.openForQuestionsCommentary({
      commentId: this.commentId,
      questionId: this.questionId
    });
  }

  changeCommentType(e) {
    const data = e.currentTarget.dataset;
    const commentary_id = parseInt(data.id);
    const segment_id = parseInt(data.segmentId);

    Thor.Commentary.recommend(
      {},
      {
        data: {
          commentary_id,
          segment_id
        }
      }
    )
      .then(() => {
        EventManager.publish(
          `questionBelt.${this.questionId}.comments.updateTotal`,
          -1
        );
        EventManager.publish(
          `questionBelt.${this.questionId}.commentsTeachers.updateTotal`,
          1
        );
        window.QuestionBelt.loadTab(
          this.$context.parents('.q-question-belt'),
          'question_comments',
          true
        );
      })
      .catch(({ response }) => {
        errorInterpreter({
          response
        });
      });
  }
}
